import React from 'react';
import HelpPageFooterNotice from '../components/helpPageFooterNotice';

const ManageUsersHelp: React.FC = () => {
  return (
    <>
      <h1>Manage Users</h1>
      <p>
        {
          'The "Manage Users" page will default to display the "Active" users within your account. You can filter users within your account by full or partial “Username”, “Email Address”, “Status”, and/or “Role”.'
        }
      </p>
      <h2>Search Filters</h2>
      <p>
        <strong>Username:</strong>
        The username assigned to an individual. (allows partial match)
      </p>
      <p>
        <strong>Email Address:</strong>
        The email address assigned to an individual user. (allows partial match)
        user.
      </p>
      <p>
        <strong>Status:</strong>
        {
          ' Used to search for users based on "Status". Active and Inactive users will be displayed by selecting the "Any" status. Selecting the "Active" or "Inactive" status will only display the users assigned with that status.'
        }
      </p>
      <p>
        <strong>Role:</strong>
        {
          ' You may search for users based on the "Role" within your account. "Administrator" role will have access to all the tools within your account. The "Agent" role is assigned to users in your account who do not have permission to use the edit/update tools available in the "Account Settings" dropdown.'
        }
      </p>
      <h2>Edit Users</h2>
      <p>
        {
          "To edit a user in your account, you'll simply need to click on anywhere along the line of the user you'd like to update. Available edits that can be made to an existing user include:"
        }
      </p>
      <p>
        <strong>Status:</strong>
        {' Disable access by changing the user from "Active" to "Inactive".'}
      </p>
      <p>
        <strong>Role:</strong>
        {
          ' Assigning a user to the "Agent" role allows access to all the tools except for the "Trips Monitored Report" under the "Trips" dropdown menu and those that appear in the "Account Settings" dropdown menu. The "Administrator" role should be assigned to individuals that require access to either of those.'
        }
      </p>
      <p>
        <strong>Assigned Organization:</strong>
        {
          ' This allows you to grant access to all Trips within your account or limit the view to specific Trips in your account based on your "Assigned Organization" structure.'
        }
      </p>
      <h2>Create New User</h2>
      <p>
        {
          'The "Create New User" link is available in the top right of the "Manage Users" page. This is what you\'ll need to use to create a new user within your account. Required information when doing so includes:'
        }
      </p>
      <p>
        <strong>Username:</strong>
        {
          " This is the username that will be used for an individual to log into your account. Cirium recommends using the individual's email address for the username."
        }
      </p>
      <p>
        <strong>Password:</strong>
        An alphanumeric password must be assigned when creating a new user with
        a minimum of 8 characters.
      </p>
      <p>
        <strong>Confirm Password:</strong>
        Re-enter the password that you assigned in the Password field.
      </p>
      <p>
        <strong>Email Address:</strong>
        {" Enter the user's email address in this field."}
      </p>
      <p>
        <strong>Status:</strong>
        {' New users should be assigned to an "Active" role.'}
      </p>
      <p>
        <strong>Role:</strong>
        {
          ' Assigning a user to the "Agent" role allows access to all the tools except for those that appear in the "Account Settings" dropdown menu. The "Administrator" role should be assigned to individuals that require access to the tools in the "Account Settings" dropdown menu.'
        }
      </p>
      <p>
        <strong>Assigned Organization:</strong>
        {
          ' This allows you to grant access to all Trips within your account or limit the view to specific Trips in your account based on your "Assigned Organization" structure.'
        }
      </p>
      <HelpPageFooterNotice />
    </>
  );
};
export default ManageUsersHelp;
